import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { interval, Subscription } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

@Component({
    selector: 'app-icons-page',
    templateUrl: './icons-page.component.html',
    styleUrls: ['./icons-page.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class IconsPageComponent implements OnInit, OnDestroy {

    public icons: string[] = [];
    private iconInterval: Subscription;
    public query: string = '';

    constructor() {
    }

    ngOnInit() {
        this.iconInterval = interval(5).pipe(
            map(() => document.querySelectorAll('say-spritesheet symbol')),
            distinctUntilChanged()
        ).subscribe(
            symbols => {
                const newIcons = Array.from(symbols).map((el: Element) => el.id).sort();

                if (newIcons.length === 0) {
                    return;
                }

                this.icons = newIcons;
            }
        );
    }

    ngOnDestroy() {
        this.iconInterval.unsubscribe();
    }

    public getURL(icon: string): string {
        return `#${icon}`;
    }

    public isIconVisible(icon: string): boolean {
        return icon.includes(this.query);
    }
}
